import React, { useEffect, useState } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import { Empty, Form, Input, List, Modal, Typography } from 'antd';

import { CommentHistoryItem, SchoolUpdate } from '../../../../../../../app/types/unApi';
import { formatCommentDate } from '../../../../../../../helpers/utils/time';
import { showErrorMessage } from '../../../../../../../helpers/utils/ui';
import { unApi } from '../../../../../api/endpoints/reports/unApi';

const EditSchool = ({ editSchoolModalVisible, setEditSchoolModalVisible, id, loadRows }:any) => {
    const [ form ] = Form.useForm();
    const [ formLoading, setFormLoading ] = useState(false);
    // История комментариев (read-only, новые сверху)
    const [ commentHistory, setCommentHistory ] = useState<CommentHistoryItem[]>([]);

    const fetchData =  async () => {
        setFormLoading(true);
        try{
            const response = await unApi.getSchoolInfo(Number(id));
            const { comment, comment_history, ...rest } = response.data;
            form.resetFields();
            // Поле нового комментария оставляем пустым — старые не затираем
            form.setFieldsValue({ ...rest, comment: '' });
            if (Array.isArray(comment_history) && comment_history.length > 0) {
                setCommentHistory(comment_history);
            } else if (comment) {
                // Легаси: истории нет, но есть старый комментарий — показываем без автора/даты
                setCommentHistory([ { comment, user_name: '', created_at: '' } ]);
            } else {
                setCommentHistory([]);
            }
        }catch(err){
            showErrorMessage('Произошла ошибка, повторите попытку позже.');
        }finally{
            setFormLoading(false);

        }
    };

    useEffect(() => {
        if (editSchoolModalVisible) {
            fetchData();
        }
    }, [ editSchoolModalVisible ]);

    const editPayment = async (values: SchoolUpdate) => {
        setFormLoading(true);
        try{
            const response = await unApi.updateSchoolInfo({ ...values,school_id :Number(id) });
            if(response.status === 200){
                form.resetFields();
                setEditSchoolModalVisible(false);
                loadRows();
                Modal.info({
                    title: 'Успех!',
                    content: 'Информация об школе обновлена.',
                });
            }
        }catch(err){
            showErrorMessage('Произошла ошибка, повторите попытку позже.');

        }finally{
            setFormLoading(false);
        }
    };

    return (
        <Modal
            title="Обновление школы"
            open={editSchoolModalVisible}
            onCancel={() => {setEditSchoolModalVisible(false);}}
            onOk={() => {form.submit();}}
            okButtonProps={{ loading: formLoading }}
            okText="Сохранить"
        >
            {
                formLoading ?
                    <div className="loading-container">
                        <LoadingOutlined style={{ fontSize: 24 }} spin />
                    </div>
                    :
                    <Form
                        form={form}
                        onFinish={editPayment}
                        labelCol={{ span: 11 }}
                        wrapperCol={{ span: 16 }}
                        requiredMark={false}
                    >
                        <Form.Item
                            name="school_name"
                            label="Название школы"
                            rules={[ { required: true } ]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            name="domain"
                            label="Основной домен"
                            rules={[ { required: false } ]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            name="chat_url"
                            label="Ссылка на чат Telegram"
                            rules={[ { required: false, type: 'url' } ]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            name="chat_url_max"
                            label="Ссылка на чат MAX"
                            rules={[ { required: false, type: 'url' } ]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            name="comment"
                            label="Новый комментарий"
                            rules={[ { required: false } ]}
                        >
                            <Input.TextArea placeholder="Добавить комментарий…" />
                        </Form.Item>

                        <div style={{ marginTop: 12 }}>
                            <Typography.Text strong>История комментариев</Typography.Text>
                            {commentHistory.length === 0 ? (
                                <Empty description="Комментариев ещё нет" image={Empty.PRESENTED_IMAGE_SIMPLE} />
                            ) : (
                                <List
                                    size="small"
                                    dataSource={commentHistory}
                                    style={{ maxHeight: 240, overflowY: 'auto' }}
                                    renderItem={(item) => (
                                        <List.Item>
                                            <div>
                                                <div style={{ whiteSpace: 'pre-wrap' }}>{item.comment}</div>
                                                {(item.user_name || item.created_at) && (
                                                    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                        {item.user_name}
                                                        {item.user_name && item.created_at ? ' · ' : ''}
                                                        {formatCommentDate(item.created_at)}
                                                    </Typography.Text>
                                                )}
                                            </div>
                                        </List.Item>
                                    )}
                                />
                            )}
                        </div>
                    </Form>
            }
        </Modal>
    );
};

export default EditSchool;
